import React, { useState, useCallback } from "react";
import { Container, Button, Card } from "react-bootstrap";
import NavbarComp from "../../shared/components/Navbar";
import { IoAddCircleOutline } from "react-icons/io5";
import AlertMessage from "../../shared/components/Alert";
import { useOrder } from "./hooks/useOrder";
import OrdersTable from "./components/OrdersTable";
import PaginationControls from "./components/PaginationControls";
import SearchAndFilter from "./components/SearchAndFilter";
import SortControls from "./components/SortControls";

const OrderPage = () => {
  const {
    orders,
    loading,
    error,
    alert,
    pagination,
    meta,
    hasNextPage,
    hasPreviousPage,
    goToPage,
    changeLimit,
    changeSort,
    toggleSortOrder,
    search,
    nextPage,
    previousPage,
    firstPage,
    lastPage,
    currentSortField,
    currentSortOrder,

    // Filter functions
    filters,
    updateCategoryFilter,
    updatePaymentStatusFilter,
    updateXenditStatusFilter,
    clearFilters,

    // 🎯 BARU: fetch semua data untuk export
    fetchAllForExport,
  } = useOrder();

  const [searchTerm, setSearchTerm] = useState("");

  // Ambil nilai filter dari hook
  const selectedCategory = filters.category;
  const selectedPaymentStatus = filters.paymentStatus;
  const selectedXenditStatus = filters.xenditStatus;

  // Handle search
  const handleSearch = useCallback(
    (e) => {
      e.preventDefault();
      search(searchTerm);
    },
    [searchTerm, search],
  );

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  // Handle filter changes
  const handleCategoryChange = useCallback(
    (category) => {
      updateCategoryFilter(category);
    },
    [updateCategoryFilter],
  );

  const handlePaymentStatusChange = useCallback(
    (status) => {
      updatePaymentStatusFilter(status);
    },
    [updatePaymentStatusFilter],
  );

  const handleXenditStatusChange = useCallback(
    (status) => {
      updateXenditStatusFilter(status);
    },
    [updateXenditStatusFilter],
  );

  const handleClearFilters = useCallback(() => {
    clearFilters();
    setSearchTerm("");
  }, [clearFilters]);

  // Handle sort
  const handleSort = useCallback(
    (field) => {
      toggleSortOrder(field);
    },
    [toggleSortOrder],
  );

  // Handle pagination
  const handlePageChange = useCallback(
    (page) => {
      goToPage(page);
    },
    [goToPage],
  );

  const handleLimitChange = useCallback(
    (limit) => {
      changeLimit(limit);
    },
    [changeLimit],
  );

  return (
    <>
      <NavbarComp />

      <AlertMessage
        show={alert.show}
        variant={alert.variant}
        message={alert.message}
        onClose={() => {}}
      />

      <Container fluid className="mt-2 mt-md-4 px-3 px-md-4">
        {/* Header Card */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Body>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
              <div>
                <h2 className="mb-1">Order Management</h2>
                <p className="text-muted mb-0">
                  Total: {meta.totalItems || 0} orders | Page {pagination.page}{" "}
                  of {meta.totalPages || 1}
                </p>
                {selectedCategory !== "ALL" && (
                  <small className="text-muted">
                    Filtered by:{" "}
                    {selectedCategory !== "ALL" &&
                      `Category: ${selectedCategory}`}
                    {selectedCategory !== "ALL" &&
                      selectedPaymentStatus !== "ALL" &&
                      ", "}
                    {selectedPaymentStatus !== "ALL" &&
                      `Payment: ${selectedPaymentStatus}`}
                    {(selectedCategory !== "ALL" ||
                      selectedPaymentStatus !== "ALL") &&
                      selectedXenditStatus !== "ALL" &&
                      ", "}
                    {selectedXenditStatus !== "ALL" &&
                      `Xendit: ${selectedXenditStatus}`}
                  </small>
                )}
              </div>
              {/* <Button
                variant="success"
                className="d-flex align-items-center gap-2 px-4"
                onClick={() => handleOpenModal()}
              >
                <IoAddCircleOutline size={20} />
                Tambah Order
              </Button> */}
            </div>
          </Card.Body>
        </Card>

        {/* Search and Filter Card */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Body>
            <SearchAndFilter
              searchTerm={searchTerm}
              selectedCategory={selectedCategory}
              selectedPaymentStatus={selectedPaymentStatus}
              selectedXenditStatus={selectedXenditStatus}
              onSearchChange={handleSearchChange}
              onSearchSubmit={handleSearch}
              onCategoryChange={handleCategoryChange}
              onPaymentStatusChange={handlePaymentStatusChange}
              onXenditStatusChange={handleXenditStatusChange}
              onClearFilters={handleClearFilters}
            />
          </Card.Body>
        </Card>

        {/* Sort Controls Card */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Body>
            <SortControls
              currentSortField={currentSortField}
              currentSortOrder={currentSortOrder}
              onSortChange={handleSort}
            />
          </Card.Body>
        </Card>

        {/* Main Content Card */}
        <Card className="border-0 shadow-sm">
          <Card.Body>
            {/* Orders Table */}
            <OrdersTable
              orders={orders}
              loading={loading}
              error={error}
              pagination={pagination}
              meta={meta}
              currentSortField={currentSortField}
              currentSortOrder={currentSortOrder}
              onSort={handleSort}
              // 🎯 BARU: kirim fungsi fetch semua data untuk export
              onFetchAllForExport={fetchAllForExport}
              // onEdit={handleOpenModal}
              // onDelete={handleDeleteOrder}
              // onView={handleViewOrder}
            />

            {/* Pagination Controls */}
            {!loading && !error && orders.length > 0 && (
              <PaginationControls
                pagination={pagination}
                meta={meta}
                hasNextPage={hasNextPage}
                hasPreviousPage={hasPreviousPage}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
                onFirstPage={firstPage}
                onLastPage={lastPage}
                onNextPage={nextPage}
                onPreviousPage={previousPage}
              />
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* Modal untuk create/edit (opsional) */}
      {/* <OrderModal ... /> */}

      {/* Modal untuk view detail (opsional) */}
      {/* <OrderViewModal ... /> */}
    </>
  );
};

export default OrderPage;